import { func } from 'prop-types'
import { kuiperClassNames } from '@opallabs/kuiper'
import { Button } from '@opallabs/lapidary'

const UnauthorizedError = ({ joinBrand }) => (
  <section
    className={kuiperClassNames(
      'error-display-week-view',
      'error-display-unauthorized'
    )}
  >
    <h2>You are not currently a member of this Workspace.</h2>
    <p>
      If you were attempting to view content within this workspace, please join
      the workspace and click the link that brought you here again.
    </p>
    <Button
      buttonText="Join Workspace"
      name="join-workspace"
      onClick={() => joinBrand().then(() => window.location.reload(true))}
    />
  </section>
)

UnauthorizedError.propTypes = {
  joinBrand: func.isRequired,
}

export default UnauthorizedError
